<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import ApplicationUserManager from '@/services/auth-service'
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState({
      authenticated: state => state.login.authenticated,
      user: state => state.login.user
    })
  },
  async created () {
    console.log('sadfdasfasfds')
    if (!this.authenticated) {
      await ApplicationUserManager.silentLogin()
    }
    if (!this.authenticated) {
      ApplicationUserManager.login()
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto');

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.content-block {
  padding-top: 3.25rem;
}
</style>
